export const occupations: { label: string; value: string }[] = [
  { label: "ご職業をお選びください", value: "" },
  { label: "会社員", value: "会社員" },
  { label: "公務員", value: "公務員" },
  { label: "自営業", value: "自営業" },
  { label: "学生", value: "学生" },
  { label: "主婦", value: "主婦" },
  { label: "その他", value: "その他" }
];